import React, { useState } from 'react'
import axios from 'axios';

const Signup = ({ setShowLogin, setShowSignup }) => {

  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    category: '',
    password: '',
    client_id: '',
    ref_id: ''
  })

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!/^\d+$/.test(formData.phone)) {
      setError('Phone number must be numeric');
      return;
    }

    if (formData.password.length < 4) {
      setError('Password must be at least 4 characters long');
      return;
    }

    try {
      await axios.post('http://localhost:3002/api/signup', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setShowSignup(false);
      setShowLogin(true);
      alert('Signed In Successfully.');
      setFormData({ name: '', phone: '', category: '', password: '', client_id: '', ref_id: '' });
    }
    catch (error) {
      console.log('Cannot create account', error.response || error.message);
      setError(error.response?.data || 'Cannot create account. Try again later.')
    }
  };


  return (
    <>
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-subheading'><hr /><span>Signin</span><hr /></p>
          <p className='sec-heading'>Create an Account</p>

          <div className='bg-body-tertiary px-4 py-5 mt-4 col-lg-6 col-md-10 col-12 mx-auto text-start'>
            <form className="row g-3" onSubmit={handleSubmit}>
              <div className="col-12">
                <input type="text" className="form-input" name='name' value={formData.name} onChange={handleInputChange} placeholder='Your Name' required />
              </div>
              <div className="col-md-6">
                <input type="tel" className="form-input" name='phone' minLength={10} maxLength={10} value={formData.phone} placeholder='Your Phone' onChange={handleInputChange} required />
              </div>
              <div className="col-md-6">
                <select className="form-input" name='category' value={formData.category} onChange={handleInputChange} required>
                  <option className="contact-input" value="" selected disabled>Select Role</option>
                  <option className="contact-input" value="Associate">Associate</option>
                  <option className="contact-input" value="Employee">Employee</option>
                </select>
              </div>
              <div className='col-md-6'>
              <input type="text" className="form-input" name='client_id' value={formData.client_id} onChange={handleInputChange} placeholder='Your User Id' required />
              </div>
              <div className='col-md-6'>
              <input type="text" className="form-input" name='ref_id' value={formData.ref_id} onChange={handleInputChange} placeholder='Refer Id' />
              </div>
              <div className="col-12">
                <input type="password" className="form-input" name='password' value={formData.password} onChange={handleInputChange} placeholder='Your Password' required />
              </div>
              {error && <div className="text-danger">{error}</div>}
              <div className="col-12 my-4">
                <button type="submit" className="banner-btn w-100">Sign In</button>
              </div>
            </form>
            {/* form ends */}
            <p className='text-center fst-italic'>Already have an Account? <span className='toggle-link' onClick={() => { setShowSignup(false); setShowLogin(true) }}>Login</span> Here.</p>
          </div>

        </div>
      </section>
    </>
  )
}

export default Signup
